import {Directive} from '@angular/core';
import {HostListener} from '@angular/core';

import {UIDialogService} from './dialog.service';

@Directive({ selector: '[uiDialogClose]' })
export class UIDialogCloseDirective {

    constructor(private _dialogService: UIDialogService) {
    }

    @HostListener('click')
    private _onClick(): void {
        this._dialogService.close();
    }

}